import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    planId: String
  }
  
  static targets = [
    "weeklyOptions",
    "listHeader"
  ];

  connect(){
  }
  
  toggleCollapseIcon(e){
    var report_id = e.target.closest(".report-toggle").getAttribute("data-report-id")
    $(`#toggle-icon-${report_id}`).toggleClass('fa-chevron-up');
    $(`#toggle-icon-${report_id}`).toggleClass('fa-chevron-down');
  }

  toggleRecipientCollapseIcon(e){
    var recipientList = e.target.closest(".recipient-list");
    if (!recipientList) { return; }

    var chevron = recipientList.querySelector(".recipient-toggle");
    var list = recipientList.querySelector(".recipient-collapse");

    if (!chevron || !list) { return; }
    
    $(chevron).toggleClass('fa-chevron-up');
    $(chevron).toggleClass('fa-chevron-down');
    $(list).toggleClass('d-none');

    // Update ARIA state to reflect the current visibility of the list
    var isExpanded = !list.classList.contains("d-none");
    const header = this.listHeaderTargets.find((target) =>
      recipientList.contains(target)
    );
    if (header) {
      header.setAttribute("aria-expanded", isExpanded.toString());
    }
  }

  submitForm(e){
    e.target.closest("form").submit()
  }

  changeDeliveryCadence(e){
    const weeklyOptions = this.weeklyOptionsTarget
    
    weeklyOptions.classList.toggle("d-none", e.target.value !== "weekly")
    this.submitForm(e)
  }
}
